import { Sparkles, Plus } from "lucide-react";

export default function EmptyState({ onAdd }) {
  return (
    <div className="text-center py-12 px-6">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-slate-100 dark:bg-slate-800 mb-3">
        <Sparkles className="text-slate-400 dark:text-slate-500" size={22} />
      </div>
      <p className="text-slate-500 dark:text-slate-400 text-sm" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "1.05rem" }}>
        Nothing planned yet for this day.
      </p>
      <button
        onClick={onAdd}
        className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-slate-900 dark:bg-slate-700 text-white text-sm font-medium hover:bg-slate-700 dark:hover:bg-slate-600 transition-colors"
      >
        <Plus size={15} /> Add something
      </button>
    </div>
  );
}
